<template>
    <v-dialog
    v-model="localValue"
    max-width="700"
  >
    <v-card>
      <v-card-title class="headline">
        Dodajte nov artikel:
      </v-card-title>

      <v-card-text>
        <AppSpinner v-if="!loaded" />
        <ArticleForm
          @save="saveAndClose"
          @cancel="cancel"
          :groups="groups"
          :categories="categories"
          :articles="articles"
          ref="articleForm"
          :modalView="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import AppSpinner from './AppSpinner'
import ArticleForm from '@/components/ArticleForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    AppSpinner,
    ArticleForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    value: {
      required: true,
      type: Boolean
    },
    article: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      loaded: false,
      localValue: this.value
    }
  },
  computed: {
    groups () {
      return objectToArray(this.$store.state.groups.items)
    },
    categories () {
      return objectToArray(this.$store.state.categories.lastLevelItems)
    },
    articles () {
      return objectToArray(this.$store.state.articles.items)
    }
  },
  methods: {
    ...mapActions('articles', { loadArticles: 'loadItems' }),
    ...mapActions('groups', { loadGroups: 'loadItems' }),
    ...mapActions('categories', { loadCategories: 'loadLastLevelItems' }),
    saveAndClose (form) {
      this.$emit('confirmed', form)
      this.clearForm()
      this.$emit('input', false)
    },
    cancel () {
      this.clearForm()
      this.$emit('input', false)
    },
    clearForm () {
      this.$refs.articleForm.clearForm()
    }
  },
  created () {
    Promise.all([
      this.loadGroups(),
      this.loadCategories(),
      this.loadArticles()
    ])
      .then(() => { this.loaded = true })
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
